import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Button, Divider } from 'antd';
import { useUpdateBreadcrumbParam } from '@/contexts/BreadcrumbContextProvider';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import WorkOrderComplementTabs from '@/components/Movements/WorkOrders/Details/Complements/WorkOrderComplementTabs';
import { useNotFoundMessage } from '@/hooks/useNotFoundMessage';
import ComplementHeader from '@/components/Movements/WorkOrders/Details/Complements/ComplementHeader';
import { useWorkorderDetailContext } from '@/components/Movements/WorkOrders/Details/WorkorderDetailProvider';
import ObservationsTimeline from '@/components/Movements/WorkOrders/Details/Observations/ObservationsTimeline';
import { useWorkOrderObservations } from '@/core/domain/workorder/WorkOrdersObservations/WorkOrdersObservations.hooks';
import WorkOrderObservationModal from '@/components/Movements/WorkOrders/Details/Observations/ObservationModal';
import WorkOrderFooter from '@/components/Movements/WorkOrders/Details/WorkOrderFooter';
import WorkorderTabExtraAction from '@/components/Movements/WorkOrders/Details/WorkorderTabExtraAction';
import workOrderValidationTabs from '@/utils/functions/workOrderValidationTabs';
import { useWorkorderForms } from '@/components/Movements/WorkOrders/Details/WorkOrderFormProvider';
import SpaceForButton from '@/components/_common/SpaceForButtons';

function WorkOrderObservationsPage({ route }: PageProps) {
  const intl = useIntl();

  const [modalVisible, modalAction] = useDisclosure();

  const {
    workorder: { data: workOrder, isLoading: isLoadingWorkOrder },
    complement: {
      data: complement,
      isLoading: isLoadingComplement,
      complementIdentifier,
    },
  } = useWorkorderDetailContext();
  const { hasFormChange } = useWorkorderForms();

  const { data: observations, isLoading } = useWorkOrderObservations(
    complement?.id,
  );

  const displayNumber = `${workOrder?.number
    .toString()
    .padStart(6, '0')}/${complement?.number.toString().padStart(2, '0')}`;

  const notFountMessage = useNotFoundMessage('workOrders.domain.customer');

  useUpdateBreadcrumbParam(':workOrderId', displayNumber || notFountMessage);

  return (
    <>
      <Helmet
        title={`${
          complementIdentifier ? `${complementIdentifier} | ` : ''
        }${intl.formatMessage({
          id: route.name,
        })}`}
      />

      <WorkOrderComplementTabs
        route={workOrderValidationTabs(
          route,
          complement?.type,
          complement?.status,
        )}
        permissions={route.permissions}
        isLoading={isLoadingWorkOrder || isLoadingComplement}
        extra={
          <SpaceForButton>
            <Button
              type="primary"
              block
              onClick={modalAction.open}
              loading={isLoadingComplement}
            >
              Adicionar Observação
            </Button>

            <WorkorderTabExtraAction />
          </SpaceForButton>
        }
      >
        <>
          <ComplementHeader />

          <ObservationsTimeline
            observations={observations}
            isLoading={isLoading}
          />

          <Divider />

          <WorkOrderFooter disabled={!hasFormChange} />

          <WorkOrderObservationModal
            visible={modalVisible}
            handleVisible={modalAction.close}
          />
        </>
      </WorkOrderComplementTabs>
    </>
  );
}

export default WorkOrderObservationsPage;
